import { render, staticRenderFns } from "./Tyontekijat.vue?vue&type=template&id=4304f414&"
import script from "./Tyontekijat.vue?vue&type=script&lang=js&"
export * from "./Tyontekijat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports